import { IDataModal } from "../..";
import ModalRedirectToPageWizard from "./modalRedirectToPageWizard";
import { TILDA_PATHS } from "../../../../shared/constants";

interface IModalTradeInProps {
  isOpen: boolean;
  data: IDataModal | null;
  onDismiss: (value: boolean) => void;
  offsetY: number;
}

const TEXT_SELL =
  "Перейдите к оформлению заявки и мы поможем продать вашу квартиру на выгодных условиях.";

const TITLE_SELL = "Помощь в продаже";

const ModalRedirectToPageWizardSell = ({
  isOpen,
  onDismiss,
  offsetY,
}: IModalTradeInProps) => {
  const handleRedirect = () => {
    window.open(TILDA_PATHS.reitInvest.sell, "_blank");
  };

  return (
    <ModalRedirectToPageWizard
      title={TITLE_SELL}
      text={TEXT_SELL}
      onRedirect={handleRedirect}
      onDismiss={onDismiss}
      isOpen={isOpen}
      offsetY={offsetY}
    />
  );
};
export default ModalRedirectToPageWizardSell;
